module.exports = __webpack_public_path__ + "img/mb_how_2.672dac90.png";